import { useQuery } from '@tanstack/react-query';
import type { TEmailProviderTemplatePayload } from 'components/FlowBuilder/FlowSidePanels/types';
import emailService from 'services/api/email.api';

const useEmailTemplate = (templateId: string) => {
  const {
    data: emailTemplate,
    error: emailTemplateError,
    isFetching: isEmailTemplateFetching,
    refetch: refetchEmailTemplate,
  } = useQuery<TEmailProviderTemplatePayload, Error>({
    queryKey: ['email-template', templateId],
    queryFn: () => emailService.getEmailTemplate(templateId),
    enabled: !!templateId,
  });

  return { emailTemplate, emailTemplateError, isEmailTemplateFetching, refetchEmailTemplate };
};

export default useEmailTemplate;
